const Courusel = ({ color }: any) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.8571 1.33398H5.14286C4.51167 1.33398 4 1.93094 4 2.66732V13.334C4 14.0704 4.51167 14.6673 5.14286 14.6673H10.8571C11.4883 14.6673 12 14.0704 12 13.334V2.66732C12 1.93094 11.4883 1.33398 10.8571 1.33398Z'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.99967 4H1.9256C1.76844 4 1.61771 4.09365 1.50657 4.26035C1.39544 4.42705 1.33301 4.65314 1.33301 4.88889V11.1111C1.33301 11.3469 1.39544 11.573 1.50657 11.7397C1.61771 11.9063 1.76844 12 1.9256 12H3.99967'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.0003 4H14.0744C14.2316 4 14.3823 4.09365 14.4934 4.26035C14.6046 4.42705 14.667 4.65314 14.667 4.88889V11.1111C14.667 11.3469 14.6046 11.573 14.4934 11.7397C14.3823 11.9063 14.2316 12 14.0744 12H12.0003'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Courusel
